import { LocationModel } from "../_models/LocationModel";
import { LOCATION_PERMISSIONS } from "../_constants/permissions.constants";

export class LocationMapper {

    static mapAllServerToLocal(serverLocations) {
        const localLocationsByUid = new Map();

        for (const serverUserType in serverLocations) {
            serverLocations[serverUserType].forEach(serverLocation => {
                const localLocation = locationServerToLocal(
                    serverLocation,
                    serverUserType,
                );
                const previous = localLocationsByUid.get(localLocation.uid);

                // El backend puede devolver la misma localización en varios
                // cubos a la vez: un admin que reserva su propio alojamiento
                // sale en `admin` y también en `no_access`, porque la
                // invitación de la estancia ya está aceptada pero todavía no
                // es vigente. Un cubo sin acceso no puede tapar a uno con rol
                // usable; en el resto de casos gana el último, como hasta ahora.
                if (previous && hasAccess(previous) && !hasAccess(localLocation))
                    return;

                // Reinsertamos para que la localización quede en la posición
                // del cubo ganador, igual que con el splice + push anterior.
                localLocationsByUid.delete(localLocation.uid);
                localLocationsByUid.set(localLocation.uid, localLocation);
            });
        }

        return Array.from(localLocationsByUid.values());
    }
}

function hasAccess(localLocation) {
    return localLocation.userType !== LOCATION_PERMISSIONS.NO_ACCESS;
}

function locationServerToLocal(serverLocation, serverUserType) {
    const {
        name,
        loc_id,
        loc_uid,
        invitation_uid,
        allows_subinvitations,
        timezone
    } = serverLocation;

    return LocationModel({
        userType: serverToLocalUserType(serverUserType),
        name,
        id: loc_id,
        uid: loc_uid,
        invitationUid: invitation_uid,
        allowsSubinvitations: allows_subinvitations,
        timezone
    });

    function serverToLocalUserType(serverUserType) {
        switch(serverUserType) {
            case "owner":
                return LOCATION_PERMISSIONS.OWNER;

            case "admin":
                return LOCATION_PERMISSIONS.ADMIN;

            case "installer":
                return LOCATION_PERMISSIONS.INSTALLER;

            case "guest":
                return LOCATION_PERMISSIONS.GUEST;

            case "no_access":
                return LOCATION_PERMISSIONS.NO_ACCESS;

            default:
                return -1;
        }
    }
}
